import { ca } from '@cian/analytics';

export const trackListingCompilationsShow = () => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'BlackFriday',
    name: 'oldevent',
    label: 'co_promos',
  });
};
